import React from "react";
import MuiTextField, {
  TextFieldProps
} from "@material-ui/core/TextField/TextField";
import { colors } from "@material-ui/core";

import { useField } from "../Form/useField";
import _ from "lodash";
import { palette } from "../../constants/palette";
import { Icon } from "../icons/Icon";

type Props = TextFieldProps & {
  name: string;
  required?: boolean;
  destroyValueOnUnmount?: boolean;
  defaultValue?: number | null;
  checkWarning?: (input: string) => string | undefined;
  inputRegxString?: string;
  validate?: (input: string) => string | undefined;
};

const FormNumberField: React.FC<Props> = ({
  name,
  required,
  defaultValue,
  destroyValueOnUnmount = false,
  checkWarning,
  validate,
  inputRegxString,
  ...textProps
}) => {
  const { value, onChange, meta } = useField({
    name,
    required,
    destroyValueOnUnmount,
    checkWarning,
    validate,
    defaultValue: _.isNil(defaultValue) ? "" : defaultValue
  });
  const inputRegx = !inputRegxString ? null : new RegExp(inputRegxString);

  return (
    <MuiTextField
      {...textProps}
      required={required}
      onChange={(event) => {
        if(inputRegx && !inputRegx.test(event.target.value)){
          return
        }
        return onChange(event)
      }}
      value={value}
      helperText={getHintText(meta)}
    />
  );
};

function getHintText(meta: any) {
  if (!meta) return "";
  if (meta.warning)
    return (
      <span
        style={{
          wordBreak: "break-word",
          color: colors.amber[600],
          lineHeight: "1rem"
        }}
      >
        <Icon
          name="warning"
          style={{ fontSize: "1em", paddingTop: 1, paddingRight: 2 }}
        />
        {meta.warning}
      </span>
    );
  if (meta.error)
    return (
      <span
        style={{
          wordBreak: "break-word",
          color: palette.ERROR,
          lineHeight: "1rem"
        }}
      >
        <Icon
          name="error"
          style={{ fontSize: "1em", paddingTop: 1, paddingRight: 2 }}
        />
        {meta.error}
      </span>
    );
  return "";
}

export default FormNumberField;
